module.exports = __webpack_public_path__ + "static/media/education-aid.f06a3048.png";